import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_16e3b882 from 'nuxt_plugin_plugin_16e3b882' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_39d29167 from 'nuxt_plugin_plugin_39d29167' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_workbox_6d692931 from 'nuxt_plugin_workbox_6d692931' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_0ca2af44 from 'nuxt_plugin_metaplugin_0ca2af44' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_index_15e8fef8 from 'nuxt_plugin_index_15e8fef8' // Source: ../plugins/logger/index.ts (mode: 'all')
import nuxt_plugin_index_e8a850ec from 'nuxt_plugin_index_e8a850ec' // Source: ../plugins/axios/index.ts (mode: 'all')
import nuxt_plugin_cookie_7193954c from 'nuxt_plugin_cookie_7193954c' // Source: ../plugins/cookie (mode: 'all')
import nuxt_plugin_errorhandler_1dde38cf from 'nuxt_plugin_errorhandler_1dde38cf' // Source: ../plugins/error-handler (mode: 'all')
import nuxt_plugin_directive_36717199 from 'nuxt_plugin_directive_36717199' // Source: ../plugins/directive (mode: 'client')
import nuxt_plugin_calendar_2f137e98 from 'nuxt_plugin_calendar_2f137e98' // Source: ../plugins/calendar (mode: 'client')
import nuxt_plugin_snackbar_03572e7b from 'nuxt_plugin_snackbar_03572e7b' // Source: ../plugins/snackbar (mode: 'client')
import nuxt_plugin_alert_3571b0b4 from 'nuxt_plugin_alert_3571b0b4' // Source: ../plugins/alert (mode: 'client')
import nuxt_plugin_loading_0a3fd5f4 from 'nuxt_plugin_loading_0a3fd5f4' // Source: ../plugins/loading (mode: 'client')
import nuxt_plugin_wc_5d03b67c from 'nuxt_plugin_wc_5d03b67c' // Source: ../plugins/wc (mode: 'client')
import nuxt_plugin_vuexpersist_13f465a2 from 'nuxt_plugin_vuexpersist_13f465a2' // Source: ../plugins/vuex-persist (mode: 'client')
import nuxt_plugin_meta_1a2d9a39 from 'nuxt_plugin_meta_1a2d9a39' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"OUND 관리자","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"script":[{"type":"text\u002Fjavascript","src":"https:\u002F\u002Fcdn.tiny.cloud\u002F1\u002Fxxhqir4qe8f4df4f7zrr5k2xvhyej96dqlafzz0h9677povr\u002Ftinymce\u002F6\u002Ftinymce.min.js","referrerpolicy":"origin","mode":"client","ssr":false},{"hid":"stripe","src":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002Fswiper@9\u002Fswiper-element-bundle.min.js","defer":true}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_16e3b882 === 'function') {
    await nuxt_plugin_plugin_16e3b882(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_39d29167 === 'function') {
    await nuxt_plugin_plugin_39d29167(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_6d692931 === 'function') {
    await nuxt_plugin_workbox_6d692931(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_0ca2af44 === 'function') {
    await nuxt_plugin_metaplugin_0ca2af44(app.context, inject)
  }

  if (typeof nuxt_plugin_index_15e8fef8 === 'function') {
    await nuxt_plugin_index_15e8fef8(app.context, inject)
  }

  if (typeof nuxt_plugin_index_e8a850ec === 'function') {
    await nuxt_plugin_index_e8a850ec(app.context, inject)
  }

  if (typeof nuxt_plugin_cookie_7193954c === 'function') {
    await nuxt_plugin_cookie_7193954c(app.context, inject)
  }

  if (typeof nuxt_plugin_errorhandler_1dde38cf === 'function') {
    await nuxt_plugin_errorhandler_1dde38cf(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_directive_36717199 === 'function') {
    await nuxt_plugin_directive_36717199(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_calendar_2f137e98 === 'function') {
    await nuxt_plugin_calendar_2f137e98(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_snackbar_03572e7b === 'function') {
    await nuxt_plugin_snackbar_03572e7b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_alert_3571b0b4 === 'function') {
    await nuxt_plugin_alert_3571b0b4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_loading_0a3fd5f4 === 'function') {
    await nuxt_plugin_loading_0a3fd5f4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_wc_5d03b67c === 'function') {
    await nuxt_plugin_wc_5d03b67c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersist_13f465a2 === 'function') {
    await nuxt_plugin_vuexpersist_13f465a2(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_1a2d9a39 === 'function') {
    await nuxt_plugin_meta_1a2d9a39(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
